const esc = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const FOURF = ["fight", "flight", "freeze", "fawn"];

export function adminCsv(data, range) {
  const t = data.totals;
  const rows = [
    ["Triggerific-Pilot admin stats", new Date().toISOString().slice(0, 16).replace("T", " "), range], [],
    ["Metric", "Value"],
    ["All accounts", t.totalUsers], ["Active users", t.contributors], ["New sign-ups", t.newSignups],
    ["Check-ins", t.totalCheckins], ["Triggers", t.totalTriggers], ["Schema activations", t.totalSchemaActivations],
    ["Avg distress drop", t.avgDrop], ["Emergency time (seconds)", t.emergencySeconds], ["Emergency sessions", t.emergencySessions],
    ["Avg emergency session (seconds)", t.avgEmergencySeconds], ["Reach-out screen shown", t.reachOut?.shown ?? 0], ["Reached out %", t.reachOutRate],
    ["Low moods (< -3)", t.lowMoods], ["Low moods that used the override", t.lowMoodOverrides], ["Override rate %", t.lowMoodOverrideRate],
    ["Avg mood lift after override", t.avgLowMoodLift ?? ""],
    ["Flips", t.flips.total], ["Flip actions", t.flips.actions], ["Flip actions done", t.flips.done], [],
    ["Date", "Emergency seconds", "Emergency sessions"], ...t.emergencyByDay.map((d) => [d.date, d.seconds, d.n]), [],
    ["Week of", "Active users", "Returning users", "Return rate %"], ...t.retention.map((w) => [w.week, w.active, w.returning, w.rate ?? ""]), [],
    ["Churned user", "Name", "Last check-in", "Days ago"], ...t.churned.map((c) => [c.email, c.name, c.lastActive, c.daysAgo]), [],
    ["Date", "New sign-ups"], ...t.signupsByDay.map((d) => [d.date, d.n]), [],
    ["Date", "Average mood", "Mood logs"], ...t.moodByDay.map((d) => [d.date, d.avg, d.n]), [],
    ["4-F response", "Count"], ...FOURF.map((k) => [k, t.fourF?.[k] ?? 0]), [],
    ["Category", "Name", "Count"],
    ...Object.entries(t.coping).map(([k, v]) => ["Tool", k, v]),
    ...Object.entries(t.modes).map(([k, v]) => ["Coping mode", k, v]),
    ...Object.entries(t.soundPicks).map(([k, v]) => ["Calming sound", k, v]),
    ...Object.entries(t.reachOut).map(([k, v]) => ["Reach out", k, v]),
    ...Object.entries(t.schemaStates).map(([k, v]) => ["Schema state", k, v]),
    ...Object.entries(t.schemas).map(([k, v]) => ["Schema", k, v]),
    ...Object.entries(t.flips.styles).map(([k, v]) => ["Coping style", k, v]),
    ...Object.entries(t.flips.needs).map(([k, v]) => ["Unmet need", k, v]), [],
    ["Email", "Name", "Joined", "Last check-in", "Check-ins", "Triggers", "Schemas", "Fight", "Flight", "Freeze", "Fawn", "Flips", "Needs ticked", "Healthy wins"],
    ...data.rows.map((r) => [r.email, r.name, r.joined.slice(0, 10), r.lastActive?.slice(0, 10) ?? "", r.totalCheckins, r.totalTriggers, r.totalSchemaActivations,
      ...FOURF.map((k) => r.fourF?.[k] ?? 0), r.flips, r.needsTicked, r.healthyWins]),
  ];
  const csv = rows.map((r) => r.map(esc).join(",")).join("\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `triggerific-stats-${range.toLowerCase().replace(/ /g, "-")}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
